import ua from '@/utils/ua'

export default function doPay(options, wx) {
  return webPay(options, wx)
}

function webPay(options, wx) {
  const { redirect_url } = options
  return ua.isWechat ? wechatPay(options, wx) : wapPay(redirect_url)
}

function wechatPay(options, wx) {
  return new Promise(resolve => {
    wx &&
      wx.chooseWXPay({
        timeStamp: options.timestamp,
        nonceStr: options.nonceStr,
        package: options.package,
        paySign: options.paySign,
        signType: options.signType,
        success: res => {
          resolve({
            err: 0,
            res
          })
        },
        fail: () => {
          resolve({
            err: -1
          })
        },
        cancel: () => {
          resolve({
            err: -1
          })
        }
      })
  }).catch(error => {
    console.log(error)
  })
}

function wapPay(url) {
  new Promise((resolve, reject) => {
    if (!url) reject(url)
    window.location.href = url
    resolve({
      err: 0
    })
  }).catch(error => {
    console.log(error)
  })
}
